import { ActionTree } from 'vuex';
import { EntraJobsState } from './types';
import { RootState } from '../../types';
import { Logger } from 'fsts';
import { AxiosResponse } from 'axios';
import { defaultBackendEntraJobs } from '@/shared/backend/entraJobs';
import { EntraJobsFacetSearchData } from '../../../model/smallPayloadModels/entrajobsSearchData';

const logger = new Logger('actions.entrajobs');
export const actions: ActionTree<EntraJobsState, RootState> = {
  async updateUsersFromEntra({ commit }) {
    console.log('updateUsersFromEntra hru hru :>> ');
    return defaultBackendEntraJobs
      .updateUsersFromEntra()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async syncLocalContactsWithAzureUsers({ commit }) {
    console.log('syncLocalContactsWithAzureUsers :>> ');
    return defaultBackendEntraJobs
      .syncLocalContactsWithAzureUsers()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async syncLocalGroupsAndMembersWithAzure({ commit }) {
    console.log('syncLocalGroupsAndMembersWithAzure :>> ');
    return defaultBackendEntraJobs
      .syncLocalGroupsAndMembersWithAzure()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getSharepointGroupsMembers({ commit }) {
    console.log('getSharepointGroupsMembers :>> ');
    return defaultBackendEntraJobs
      .getSharepointGroupsMembers()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async syncSharepointGroups({ commit }, data: any) {
    console.log('syncSharepointGroups :>> ');
    return defaultBackendEntraJobs
      .syncSharepointGroups(data)
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getEntraGroupsWithMembers({ commit }) {
    console.log('getEntraGroupsWithMembers :>> ');
    return defaultBackendEntraJobs
      .getEntraGroupsWithMembers()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async getVmeApiUsers({ commit }, data: any) {
    console.log('getVmeApiUsers :>> ');
    return defaultBackendEntraJobs
      .getVmeApiUsers()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async updateConditionFromVmeApiUsersTable({ commit }, data: any) {
    console.log('updateConditionFromVmeApiUsersTable :>> ');
    return defaultBackendEntraJobs
      .updateConditionFromVmeApiUsersTable()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async copyTestUserInSyncTable({ commit }, data: any) {
    console.log('copyTestUserInSyncTable :>> ');
    return defaultBackendEntraJobs
      .copyTestUserInSyncTable()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async zrPortalFullScanForZrMaster({ commit }) {
    console.log('zrPortalFullScanForZrMaster :>> ');
    return defaultBackendEntraJobs
      .zrPortalFullScanForZrMaster()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async deleteSharepointTestUser({ commit }) {
    console.log('deleteSharepointTestUser :>> ');
    return defaultBackendEntraJobs
      .deleteSharepointTestUser()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async getLastJobTime({ commit }) {
    console.log('getLastJobTime :>> ');
    return defaultBackendEntraJobs
      .getLastJobTime()
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getJobsNameList({ commit }, payload?: { entraJobsSearchData?: any }) {
    console.log('getJobsNameList :>> ');
    return defaultBackendEntraJobs
      .getJobsNameList(payload?.entraJobsSearchData)
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getEntityList({ commit }, payload?: { entraJobsSearchData?: any }) {
    console.log('getEntityList :>> ');
    return defaultBackendEntraJobs
      .getEntityList(payload?.entraJobsSearchData)
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getListAction({ commit }, payload?: { entraJobsSearchData?: any }) {
    console.log('getListAction :>> ');
    return defaultBackendEntraJobs
      .getListAction(payload?.entraJobsSearchData)
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getJobDetailLogs({ commit }, payload?: { searchParams?: any; entraJobsSearchData?: any }) {
    console.log('getJobDetailLogs :>> ');
    return defaultBackendEntraJobs
      .getJobDetailLogs(payload?.searchParams, payload?.entraJobsSearchData)
      .then((response: any) => {
        commit('setEntraJobDetailLog', response.data);
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getAllEntraJobs({ commit }) {
    return defaultBackendEntraJobs
      .getAllEntraJobs()
      .then((response: any) => {
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  getEntraJobsFacetSearch({ commit, dispatch }, payload: EntraJobsFacetSearchData) {
    return defaultBackendEntraJobs
      .getEntraJobsFacetSearch(payload)
      .then((response: AxiosResponse<any>) => {
        const result = response.data.$values ? response.data.$values : response.data;
        return result;
      })
      .catch((e: any) => {
        throw e;
      });
  },
    async updateEntraJobInterval({ commit }, payload: any) {
    console.log('updateEntraJobInterval data  :>> ', payload);
    return defaultBackendEntraJobs
      .updateEntraJobInterval(payload)
      .then((response: any) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  updateEntraJobsSearchData({ commit, dispatch }, data: any) {
    commit('setEntraJobsSearchData', data);
  },
};
